import { el } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import './index.scss';

const WARNING_LENGTH = 30000;
const REFUSAL_LENGTH = 60000;

class SourceFileInput {

  constructor(configuration) {

    this.input = null;
    this.editor = null;

    this.file = configuration.file;
    this.onChange = configuration.onChange;

    this.el = el('.source-file-input-main', [
      this.renderInput()
    ]);

  }

  buildEditorOptions() {

    const options = {
      useWorker: false,
      autoScrollEditorIntoView: true,
      copyWithEmptySelection: true,
      enableAutoIndent: true,
      tabSize: 2,
      maxPixelHeight: 300
    };

    return options;

  }

  renderInput() {

    this.input = el('.source-file-input');
    this.editor = ace.edit(this.input, this.buildEditorOptions());
    ace.config.set('basePath', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.36.5');
    this.editor.setTheme('ace/theme/monokai');
    this.editor.session.setMode('ace/mode/' + this.file.type);

    this.updateInput();

    this.editor.session.on('change', this.handleEditorChange.bind(this));

    return this.input;

  }

  handleEditorChange() {

    const value = this.editor.getValue();

    if (value.length >= REFUSAL_LENGTH) {

      this.showRefusal();

      return;

    }

    if (value.length >= WARNING_LENGTH) {

      this.showWarning();

    } else {

      this.clearMessage();

    }

    this.onChange({
      ...this.file,
      content: value
    });

  }

  showWarning() {

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'This code block is getting long and may not render well. Consider shortening it.',
      seconds: 5,
      type: 'warn'
    });

  }

  showRefusal() {

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'This code block is too long to save. Reduce it below ' + REFUSAL_LENGTH + ' characters.',
      seconds: 5,
      type: 'error'
    });

  }

  clearMessage() {

  }

  updateInput() {

    this.editor.setValue(this.file.content, -1);

  }

  update(configuration) {

    this.file = configuration.file;

    this.updateInput();

  }

}

export default SourceFileInput;